/** "cctv" module DTO unique keys */
export enum CctvDtoKeysEnum {
  /** "Hikvision" CCTV camera list APIs base filters */
  HIKVISION_CAMERA_FILTERS_DTO = 'cctv/hikvision-camera-filters.dto',
  /** "Hikvision" CCTV camera credentials find many API query parameters */
  HIKVISION_CAMERA_FIND_MANY_QUERY_DTO = 'cctv/hikvision-camera-find-many-query.dto',
  /** "Hikvision" CCTV camera export to file API query parameters */
  HIKVISION_CAMERA_EXPORT_QUERY_DTO = 'cctv/hikvision-camera-export-query.dto',
  /** "Hikvision" CCTV camera credentials find one API query parameters (additional options) */
  HIKVISION_CAMERA_FIND_ONE_QUERY_DTO = 'cctv/hikvision-camera-find-one-query.dto',
  /** "Hikvision" CCTV camera credentials response body */
  HIKVISION_CAMERA_FIND_DTO = 'cctv/hikvision-camera-find.dto',
  /** "Hikvision" CCTV camera credentials create and update APIs request body */
  HIKVISION_CAMERA_FORM_DTO = 'cctv/hikvision-camera-form.dto',
  /** "Hikvision" CCTV camera credentials list slice (JSON "page") */
  HIKVISION_CAMERA_PAGE_DTO = 'cctv/hikvision-camera-page.dto',
  /** "Hikvision" CCTV camera record stream API query parameters */
  HIKVISION_CAMERA_RECORD_STREAM_QUERY_DTO = 'cctv/hikvision-camera-record-stream-query.dto',
  /** "Hikvision" CCTV camera open barrier API query response body */
  HIVISION_CAMERA_OPEN_BARRIER_RESULT_DTO = 'cctv/hivision-camera-open-barrier-result.dto',
  /** "Hikvision" CCTV camera one vehicle APIs URL parameters */
  HIKVISION_CAMERA_VEHICLE_PARAMS_DTO = 'cctv/hikvision-camera-vehicle-params.dto',
  /** "Hikvision" CCTV camera event list API filters */
  HIKVISION_CAMERA_EVENT_FILTERS_DTO = 'cctv/hikvision-camera-event-filters.dto',
  /** "Hikvision" CCTV camera event response body */
  HIKVISION_CAMERA_EVENT_FIND_DTO = 'cctv/hikvision-camera-event-find.dto',
  /** "Hikvision" CCTV camera event request body */
  HIKVISION_CAMERA_EVENT_FORM_DTO = 'cctv/hikvision-camera-event-form.dto',
  /** "Hikvision" CCTV camera wrong category request body */
  HIKVISION_CAMERA_EVENT_WRONG_CATEGORY_FORM_DTO = 'cctv/hikvision-camera-event-wrong-category-form.dto',
  /** "Hikvision" CCTV camera guest pass request body */
  HIKVISION_CAMERA_EVENT_GUEST_PASS_FORM_DTO = 'cctv/hikvision-camera-event-guest-pass-form.dto',
  /** "Hikvision" CCTV camera event list API respons body */
  HIKVISION_CAMERA_EVENT_PAGE_DTO = 'cctv/hikvision-camera-event-page.dto',
  /** "Hikvision" CCTV camera event list API query parameters */
  HIKVISION_CAMERA_EVENT_QUERY_DTO = 'cctv/hikvision-camera-event-query.dto',
  /** "Hikvision" CCTV camera event history API respons body */
  HIKVISION_CAMERA_EVENT_HISTORY_FIND_DTO = 'cctv/hikvision-camera-event-history-find.dto',
  /** "Hikvision" CCTV camera stream channel settings */
  HIKVISION_CAMERA_STREAM_CHANNEL_DTO = 'cctv/hikvision-camera-stream-channel.dto',
  /** Transit tasks list APIs filters */
  TRANSIT_TASK_FILTERS_DTO = 'cctv/transit-task-filters.dto',
  /** Transit tasks find API query parameters */
  TRANSIT_TASK_QUERY_DTO = 'cctv/transit-task-query.dto',
  /** Transit task export to file API query parameters */
  TRANSIT_TASK_EXPORT_QUERY_DTO = 'cctv/transit-task-export-query.dto',
  /** Transit task response body */
  TRANSIT_TASK_FIND_DTO = 'cctv/transit-task-find.dto',
  /** Transit task create/update request body */
  TRANSIT_TASK_FORM_DTO = 'cctv/transit-task-form.dto',
  /** Transit task filters for "Personal Account" mode */
  TRANSIT_TASK_PERSONAL_ACCOUNT_FILTERS_DTO = 'cctv/transit-task-personal-account-filters.dto',
  /** Transit task create/update request body */
  TRANSIT_TASK_PERSONAL_ACCOUNT_FORM_DTO = 'cctv/transit-task-personal-account-form.dto',
  /** Transit task card partial update request body */
  TRANSIT_TASK_PARTIAL_FORM_DTO = 'cctv/transit-task-partial-form.dto',
  /** Unlink camera event from transit task residence (entry/exit) request body */
  TRANSIT_TASK_UNLINK_RESIDENCE_EVENT_FORM_DTO = 'cctv/transit-task-unlink-residence-event-form.dto',
  /** Transit task card partial update request body */
  TRANSIT_TASK_PERSONAL_ACCOUNT_PARTIAL_FORM_DTO = 'cctv/transit-task-personal-account-partial-form.dto',
  /** Transit task find many API query parameters for "Personal Account" mode */
  TRANSIT_TASK_PERSONAL_ACCOUNT_QUERY_DTO = 'cctv/transit-task-personal-account-query.dto',
  /** Personal-account transit task card descriptor query */
  TRANSIT_TASK_PERSONAL_ACCOUNT_CARD_DESCRIPTOR_QUERY_DTO = 'cctv/transit-task-personal-account-card-descriptor-query.dto',
  /** Transit task create request body */
  TRANSIT_TASK_CREATE_DTO = 'cctv/transit-task-create.dto',
  /** Transit task list with pagination API response body */
  TRANSIT_TASK_PAGE_DTO = 'cctv/transit-task-page.dto',
  /** Transit task sums response body */
  TRANSIT_TASK_SUMS_FIND_DTO = 'cctv/transit-task-sums-find.dto',
  /** Transit task chart response body */
  TRANSIT_TASK_CHART_FIND_DTO = 'cctv/transit-task-chart-find.dto',
  /** Transit task find one API query parameters */
  TRANSIT_TASK_FIND_ONE_QUERY_DTO = 'cctv/transit-task-find-one-query.dto',
  /** Transit task registry subtotal grouping */
  TRANSIT_TASK_SUBTOTAL_BY_DTO = 'cctv/transit-task-subtotal-by.dto',
  /** Transit task plot settings */
  TRANSIT_TASK_PLOT_SETTINGS_DTO = 'cctv/transit-task-plot-settings.dto',
  /** Transit task plot API query */
  TRANSIT_TASK_PLOT_QUERY_DTO = 'cctv/transit-task-plot-query.dto',
  /** Transit task subtotal API query */
  TRANSIT_TASK_SUBTOTAL_QUERY_DTO = 'cctv/transit-task-subtotal-query.dto',
  /** Transit task subtotal row */
  TRANSIT_TASK_SUBTOTAL_ITEM_DTO = 'cctv/transit-task-subtotal-item.dto',
  /** Transit task subtotal response */
  TRANSIT_TASK_SUBTOTAL_DTO = 'cctv/transit-task-subtotal.dto',
  /** Transit task registry total values */
  TRANSIT_TASK_REGISTRY_TOTAL_VALUES_DTO = 'cctv/transit-task-registry-total-values.dto',
  /** Transit task registry total response */
  TRANSIT_TASK_REGISTRY_TOTAL_DTO = 'cctv/transit-task-registry-total.dto',
  /** Car parking price for room response body */
  CAR_CATEGORY_ROOM_PRICE_FIND_DTO = 'cctv/car-category-room-price-find.dto',
  /** Car parking price for room create and update requests body */
  CAR_CATEGORY_ROOM_PRICE_FORM_DTO = 'cctv/car-category-room-price-form.dto',
  /** Car category find one API query parameters (additional options) */
  CAR_CATEGORY_FIND_ONE_QUERY_DTO = 'cctv/car-category-find-one-query.dto',
  /** Car category response body */
  CAR_CATEGORY_FIND_DTO = 'cctv/car-category-find.dto',
  /** Car category create/update request body */
  CAR_CATEGORY_FORM_DTO = 'cctv/car-category-form.dto',
  /** Car category partial update request body */
  CAR_CATEGORY_PARTIAL_FORM_DTO = 'cctv/car-category-partial-form.dto',
  /** Car category find API query parameters */
  CAR_CATEGORY_QUERY_DTO = 'cctv/car-category-query.dto',
  /** Car category list APIs filters */
  CAR_CATEGORY_FILTERS_DTO = 'cctv/car-category-filters.dto',
  /** Car category list with pagination API response body */
  CAR_CATEGORY_PAGE_DTO = 'cctv/car-category-page.dto',
  /** Resident card find one API query parameters (additional options) */
  RESIDENT_CAR_FIND_ONE_QUERY_DTO = 'cctv/resident-car-find-one-query.dto',
  /** Resident car response body */
  RESIDENT_CAR_FIND_DTO = 'cctv/resident-car-find.dto',
  /** Resident car create/update request body */
  RESIDENT_CAR_FORM_DTO = 'cctv/resident-car-form.dto',
  /** Resident car partial update request body */
  RESIDENT_CAR_PARTIAL_FORM_DTO = 'cctv/resident-car-partial-form.dto',
  /** Resident car find API query parameters */
  RESIDENT_CAR_QUERY_DTO = 'cctv/resident-car-query.dto',
  /** Resident car export to file API query parameters */
  RESIDENT_CAR_EXPORT_QUERY_DTO = 'cctv/resident-car-export-query.dto',
  /** Resident car list APIs filters */
  RESIDENT_CAR_FILTERS_DTO = 'cctv/resident-car-filters.dto',
  /** Resident car list with pagination API response body */
  RESIDENT_CAR_PAGE_DTO = 'cctv/resident-car-page.dto',
  /** Resident car fields selection settings */
  RESIDENT_CAR_SELECT_DTO = 'cctv/resident-car-select.dto',
  /** Resident car sums response body */
  RESIDENT_CAR_SUMS_FIND_DTO = 'cctv/resident-car-sums-find.dto',
  /** Resident car registry subtotal grouping */
  RESIDENT_CAR_SUBTOTAL_BY_DTO = 'cctv/resident-car-subtotal-by.dto',
  /** Resident car subtotal API query */
  RESIDENT_CAR_SUBTOTAL_QUERY_DTO = 'cctv/resident-car-subtotal-query.dto',
  /** Resident car subtotal row */
  RESIDENT_CAR_SUBTOTAL_ITEM_DTO = 'cctv/resident-car-subtotal-item.dto',
  /** Resident car subtotal response */
  RESIDENT_CAR_SUBTOTAL_DTO = 'cctv/resident-car-subtotal.dto',
  /** Resident car list APIs filters for personal account mode */
  RESIDENT_CAR_PERSONAL_ACCOUNT_FILTERS_DTO = 'cctv/resident-car-personal-account-filters.dto',
  /** Resident card find one API query parameters (additional options) for personal account mode */
  RESIDENT_CAR_PERSONAL_ACCOUNT_FIND_ONE_QUERY_DTO = 'cctv/resident-car-personal-account-find-one-query.dto',
  /** Resident car response body for personal account mode */
  RESIDENT_CAR_PERSONAL_ACCOUNT_FIND_DTO = 'cctv/resident-car-personal-account-find.dto',
  /** Resident car create/update request body for personal account mode */
  RESIDENT_CAR_PERSONAL_ACCOUNT_FORM_DTO = 'cctv/resident-car-personal-account-form.dto',
  /** Resident car list with pagination API response body for personal account mode */
  RESIDENT_CAR_PERSONAL_ACCOUNT_PAGE_DTO = 'cctv/resident-car-personal-account-page.dto',
  /** Resident car partial update request body for personal account mode */
  RESIDENT_CAR_PERSONAL_ACCOUNT_PARTIAL_FORM_DTO = 'cctv/resident-car-personal-account-partial-form.dto',
  /** Resident car list with pagination API response body for personal account mode */
  RESIDENT_CAR_PERSONAL_ACCOUNT_QUERY_DTO = 'cctv/resident-car-personal-account-query.dto',
  /** Resident car fields selection settings for personal account mode */
  RESIDENT_CAR_PERSONAL_ACCOUNT_SELECT_DTO = 'cctv/resident-car-personal-account-select.dto',
  /** "CCTV" module settings get and set APIs response body */
  CCTV_SETTINGS_FIND_DTO = 'cctv/cctv-settings-find.dto',
  /** "CCTV" module settings set API request body */
  CCTV_SETTINGS_FORM_DTO = 'cctv/cctv-settings-form.dto',
  /** Ordered passage (license plate) AI agents set API request body */
  PASSAGE_AI_AGENTS_FORM_DTO = 'cctv/passage-ai-agents-form.dto',
  /** Transit task and resident car manual pass APIs common URL parameters */
  PASS_CAR_PARAMS_DTO = 'cctv/pass-car-params.dto',
  /** Other vehicle manual pass API URL parameters */
  PASS_OTHER_VEHICLE_PARAMS_DTO = 'cctv/pass-other-vehicle-params.dto',
  /** Visitors report APIs common filters */
  VISITORS_REPORT_FILTERS_DTO = 'cctv/visitors-report-filters.dto',
  /** Visitors report registry entry response body */
  VISITORS_REPORT_REGISTRY_ENTRY_DTO = 'cctv/visitors-report-registry-entry.dto',
  /** Visitors report registry API query parameters */
  VISITORS_REPORT_REGISTRY_QUERY_DTO = 'cctv/visitors-report-registry-query.dto',
  /** Visitors report export to file API query parameters */
  VISITORS_REPORT_EXPORT_QUERY_DTO = 'cctv/visitors-report-export-query.dto',
  /** Visitors report registry API response body */
  VISITORS_REPORT_REGISTRY_DTO = 'cctv/visitors-report-registry.dto',
  /** Visitors report registry page API response body (v2) */
  VISITORS_REPORT_ITEMS_PAGE_DTO = 'cctv/visitors-report-items-page.dto',
  /** Visitors report subtotal entry response body */
  VISITORS_REPORT_SUBTOTAL_ENTRY_DTO = 'cctv/visitors-report-subtotal-entry.dto',
  /** Visitors report subtotal API query parameters */
  VISITORS_REPORT_SUBTOTAL_QUERY_DTO = 'cctv/visitors-report-subtotal-query.dto',
  /** Visitors report subtotal API response body */
  VISITORS_REPORT_SUBTOTAL_DTO = 'cctv/visitors-report-subtotal.dto',
  /** Event report entry response body */
  EVENT_REPORT_ENTRY_DTO = 'cctv/event-report-entry.dto',
  /** Event report entry sums response body */
  EVENT_REPORT_ENTRY_SUMS_DTO = 'cctv/event-report-entry-sums.dto',
  /** Event report API query parameters */
  EVENT_REPORT_QUERY_DTO = 'cctv/event-report-query.dto',
  /** Event report API response body */
  EVENT_REPORT_DTO = 'cctv/event-report.dto',
  /** Event report registry column selection */
  EVENT_REPORT_SELECT_DTO = 'cctv/event-report-select.dto',
  /** Event report registry sorting settings */
  EVENT_REPORT_SORT_DTO = 'cctv/event-report-sort.dto',
  /** Event report registry API query parameters */
  EVENT_REPORT_REGISTRY_QUERY_DTO = 'cctv/event-report-registry-query.dto',
  /** Event report export to file API query parameters */
  EVENT_REPORT_EXPORT_QUERY_DTO = 'cctv/event-report-export-query.dto',
  /** Event report registry page API response body (v2) */
  EVENT_REPORT_ITEMS_PAGE_DTO = 'cctv/event-report-items-page.dto',
  /** Event report subtotal entry response body */
  EVENT_REPORT_SUBTOTAL_ENTRY_DTO = 'cctv/event-report-subtotal-entry.dto',
  /** Event report subtotal API query parameters */
  EVENT_REPORT_SUBTOTAL_QUERY_DTO = 'cctv/event-report-subtotal-query.dto',
  /** Event report subtotal API response body */
  EVENT_REPORT_SUBTOTAL_DTO = 'cctv/event-report-subtotal.dto',
  /** Event report plot own settings */
  EVENT_REPORT_PLOT_SETTINGS_DTO = 'cctv/event-report-plot-settings.dto',
  /** Event report plot API query parameters */
  EVENT_REPORT_PLOT_QUERY_DTO = 'cctv/event-report-plot-query.dto',
  /** Event report manual detection API request body */
  EVENT_REPORT_MANUAL_DETECT_DTO = 'cctv/event-report-manual-detect.dto',
}
